import * as yup from 'yup';

const pagamentoPorPeriodoSchema = yup.object().shape({
  dateStart: yup.string().required('Insira uma data inicial.'),
  dateEnd: yup.string().required('Insira uma data final.'),
  numVenda: yup.number().required('Selecione um empreendimento.').moreThan(0),
});

export { pagamentoPorPeriodoSchema };
